import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  PLATFORM_ID,
} from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ContactsInterface } from '@nebalkon-workspace/content-api';
import { formatWorkSchedule } from './utils/format-work-schedule.util';
import { openExternalUrl, telHref } from './utils/open-external-url.util';

@Component({
  selector: 'lib-cabinet-help-contacts',
  imports: [TranslatePipe],
  templateUrl: './cabinet-help-contacts.component.html',
  styleUrl: './cabinet-help-contacts.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CabinetHelpContactsComponent {
  readonly #document = inject(DOCUMENT);
  readonly #platformId = inject(PLATFORM_ID);
  readonly #translate = inject(TranslateService);

  readonly contacts = input<ContactsInterface | null | undefined>();
  readonly hideSectionTitle = input(false);
  readonly hidePrimaryContacts = input(false);

  protected readonly messengers = computed(() => {
    const list = this.contacts()?.messengers;
    return Array.isArray(list) ? list : [];
  });

  protected readonly socials = computed(() => {
    const list = this.contacts()?.socials;
    return Array.isArray(list) ? list : [];
  });

  protected readonly workScheduleText = computed(() =>
    formatWorkSchedule(this.contacts()?.work.schedule, (key, params) =>
      this.#translate.instant(key, params),
    ),
  );

  protected telHref(phone: string | undefined): string {
    return telHref(phone);
  }

  protected openHttpUrl(url: string, event: Event): void {
    event.preventDefault();
    if (!isPlatformBrowser(this.#platformId)) return;
    openExternalUrl(url, this.#document.defaultView);
  }
}
